/* eslint-disable */

export const Q_TYPES = {
  QUESTON_RADIO: 'radio',
  QUESTON_LIST: 'dropdown',
  QUESTON_CHECKBOX: 'checkbox',
  QUESTON_NUMBER: 'number',
  QUESTON_TEXT: 'text',
  QUESTON_TEXTAREA: 'textarea',
  TEXT_MESSAGE: 'static_element',
  QUESTON_RANKED: 'ranked',
  QUESTON_POS_NEGATIVE: 'pos_neg_select',
}

export const Q_TYPES_NAMES = [
  {
    type: Q_TYPES.QUESTON_RANKED,
    name: 'Вопрос с ранжированием ответов',
    newTemplate: "Вопрос ",
    showInAddMenu: false,
    showInAddMenuDomain: true,
  },
  {
    type: Q_TYPES.QUESTON_RADIO,
    name: 'Закрытый вопрос с вариантами ответа',
    newTemplate: "Вопрос ",
    showInAddMenu: true,
    showInAddMenuDomain: true,
  },
  {
    type: Q_TYPES.QUESTON_LIST,
    name: 'Выбор из списка',
    newTemplate: "Вопрос ",
    showInAddMenu: true,
    showInAddMenuDomain: true,
  },
  // {
  //   type: Q_TYPES.QUESTON_CHECKBOX,
  //   name: 'Выбор нескольких вариантов',
  //   newTemplate: "Вопрос ",
  // },
  // {
  //   type: Q_TYPES.QUESTON_NUMBER,
  //   name: 'Ввод числа',
  //   newTemplate: "Вопрос ",
  // },
  // {
  //   type: Q_TYPES.QUESTON_TEXT,
  //   name: 'Ввод строки',
  //   newTemplate: "Вопрос ",
  // },
    {
      type: Q_TYPES.QUESTON_TEXTAREA,
      name: 'Ввод текста',
      newTemplate: "Вопрос ",
      showInAddMenu: true
    },
  {
    name: 'Текстовое сообщение',
    type: Q_TYPES.TEXT_MESSAGE,
    newTemplate: "Сообщение ",
    showInAddMenu: true,
    showInAddMenuDomain: true,
  },
  {
    name: 'Выбор положительных и отрицательных ответов',
    type: Q_TYPES.QUESTON_POS_NEGATIVE,
    newTemplate: "Сообщение ",
    showInAddMenu: true,
    showInAddMenuDomain: true,
  },
]


export function getQuestionName(type) {
  const questionType = Q_TYPES_NAMES.find(el => el.type == type)
  return questionType ? questionType.name : 'Тип не найден'
}
